import './placeholder.scss';

import React from 'react';
import PropTypes from 'prop-types';
import round from 'utils/round';

export const getRelativeX = (x, pageWidth) => {
  return round(x / pageWidth, 6);
};

export const getRelativeY = (y, pageHeight) => {
  return round(y / pageHeight, 6);
};

export const getRelativeWidth = (width, pageWidth) => {
  return round(width / pageWidth, 6);
};

export const getRelativeHeight = (height, pageHeight) => {
  return round(height / pageHeight, 6);
};

const withPlaceholderStyle = (Placeholder, scale = false) => {
  const WrappedPlaceholder = props => {
    const style = {};

    if (props.placeholder.angle) {
      style.transform = `rotate(${props.placeholder.angle}deg)`;
      style.transformOrigin = `top left`;
    }

    const placeholderFrame = props.placeholder.displayFrame || props.placeholder.frame;
    if (placeholderFrame) {
      const frameOffset = props.page.displayTruncatingOffset || [0, 0];

      const left = getRelativeX(placeholderFrame[0] - frameOffset[0], props.page.size.width);
      const top = getRelativeY(placeholderFrame[1] - frameOffset[1], props.page.size.height);
      let width = getRelativeWidth(placeholderFrame[2], props.page.size.width);
      let height = getRelativeHeight(placeholderFrame[3], props.page.size.height);

      if (scale) {
        width /= props.pageSizeScale || 1;
        height /= props.pageSizeScale || 1;
      }

      style.left = `${left * 100}%`;
      style.top = `${top * 100}%`;
      style.width = `${width * 100}%`;
      style.height = `${height * 100}%`;
    }

    return <Placeholder style={style} {...props} />;
  };

  WrappedPlaceholder.propTypes = {
    placeholder: PropTypes.object,
    pageSizeScale: PropTypes.number,
    page: PropTypes.object,
  };

  return WrappedPlaceholder;
};

export default withPlaceholderStyle;
